module.exports = __webpack_public_path__ + "img/details-two.4931f023.png";